if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.images = [];
        this.currentImageIndex = 0;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.images = [];
        this.setupImages();
        this.showActiveMedia();
      }

      setupImages() {
        this.querySelectorAll('.modal-image').forEach((img, index) => {
          this.images.push(img.src); // Resim URL'lerini diziye ekliyoruz
          img.addEventListener('click', () => {
            this.currentImageIndex = index;
            this.showImage(this.currentImageIndex);
          });
        });
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`)
          .forEach((element) => {
            element.classList.remove('active');
          });
        
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (activeMedia) {
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
            activeMedia.loadContent();
          }
        }
      }

      showImage(index) {
        const modalImg = this.querySelector('#modalImage');
        modalImg.src = this.images[index];

        modalImg.onload = function() {
          const aspectRatio = modalImg.naturalWidth / modalImg.naturalHeight;
          modalImg.style.width = aspectRatio > 1 ? '90%' : 'auto';
          modalImg.style.height = aspectRatio > 1 ? 'auto' : '90%';
        };

        this.querySelector('#ProductModal-{{ section.id }}').style.display = 'block';
      }

      closeModal() {
        this.querySelector('#ProductModal-{{ section.id }}').style.display = 'none';
      }
      
      showPrevImage() {
        this.currentImageIndex = (this.currentImageIndex > 0) ? this.currentImageIndex - 1 : this.images.length - 1;
        this.showImage(this.currentImageIndex);
      }

      showNextImage() {
        this.currentImageIndex = (this.currentImageIndex < this.images.length - 1) ? this.currentImageIndex + 1 : 0;
        this.showImage(this.currentImageIndex);
      }
    }
  );
}
